/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import './AdminFilter.scss';
import Icon from 'src/components/Icon/Icon';
import classNames from 'classnames';

interface AdminFilterProps {
  filters: string []
  addToFilter: (value, name) => void,
  selectedFilters: string[]
}

function AdminFilter({ filters, addToFilter, selectedFilters }: AdminFilterProps) {
  const [showFilters, setShowFilters ]= useState(false);
  const { t } = useTranslation();


  const camelCaseToWords = (text: string) => {
    const result = text.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  };

  return (
    <div className="admin-filters">
      <div className="admin-filters__subtitle-container" onClick={ () => setShowFilters(!showFilters) }>
        <h4 className="session__title">{ t('transactions.filters') }</h4>
        <Icon
          icon="arrow"
          className={
            classNames('combinations-container__dropdown-arrow',
              { 'session__dropdown-arrow--opened': showFilters,
                'session__dropdown-arrow': !showFilters
              })
          }
        />
      </div>
      {
        _.map(filters, (filter) => {
          if (showFilters || selectedFilters.includes(filter)){
            return (
              <div className="admin-filters__container">
                <span className="admin-filters__name">{ camelCaseToWords(filter) }</span>
                <input className="admin-filters__input" type="text" placeholder="item" onChange={ (e) => addToFilter(e.target.value, filter) } />
              </div>
            );
          } else {
            return null;
          }
        })
      }
    </div>
  );
}

export default AdminFilter;
